export const URL_PREFIX = '/user-center/userManage'
